
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class MenuButton extends Vue {
    @Prop({ required: false, type: String }) private caption!: string;
    @Prop({ required: true, type: String }) private icon!: string;
    @Prop({ required: false, type: Boolean, default: false }) private big!: boolean;
    @Prop({ required: false, type: Boolean, default: false }) private disabled!: boolean;

    get height(): number {
        return this.big ? 58 : 34;
    }

    public click() {
        if (!this.disabled) {
            this.$emit('click');
        }
    }
}
